import { CustomEquipmentTypes } from '../../../../shared/types/customEquipment.ts';
import { CmmBadge } from '../../../components/cmmBadge.tsx';
import { LinkButton } from '../../../components/linkButton.tsx';
import { CustomEquipment } from '../../../types/sharedTypeImpl.ts';


interface Props {
    style: React.CSSProperties;
    equipments: CustomEquipment[];
    onIsActiveChange: (equipment: CustomEquipment, isActive: boolean) => void;
    onEditClick: (equipment: CustomEquipment) => void;
}

export function CustomEquipmentsTable({
    style,
    equipments,
    onIsActiveChange,
    onEditClick,
}: Props) {
    return (
        <table style={style}>
            <thead>
                <tr>
                    <th>Is active</th>
                    <th>Id</th>
                    <th>Display name</th>
                    <th>SharePoint folder</th>
                    <th>Type</th>
                    <th>Badge</th>
                    <th>Edit</th>
                </tr>
            </thead>
            <tbody>
                {equipments?.map(it =>
                    <tr key={it._id}>
                        <td>
                            <input
                                type='checkbox'
                                checked={it.isActive}
                                onChange={(e) => onIsActiveChange(it, e.target.checked)}
                            />
                        </td>
                        <td style={{ textAlign: 'left', paddingLeft: '30px' }}>{it.name}</td>
                        <td style={{ textAlign: 'left', paddingLeft: '30px' }}>{it.displayName}</td>
                        <td style={{ textAlign: 'left', paddingLeft: '30px' }}>{it.sharepointFolder}</td>
                        <td>{CustomEquipmentTypes.find(type => type.value === it.type)?.label ?? it.type}</td>
                        <td>
                            {(it.type === 'cmm' || it.type === 'vmm') && (
                                <CmmBadge
                                    badgeText={it.badgeText}
                                    badgeColor={it.badgeColor}
                                    displayName={it.displayName}
                                />
                            )}
                        </td>
                        <td>
                            <LinkButton
                                onClick={() => onEditClick(it)}
                                content='Edit'
                            />
                        </td>
                    </tr>
                )}
            </tbody>
        </table>
    );
}
